// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___1PgR4","sorry":"styles-module__sorry___3KyQY"};